const cards = [
  {
    title: '流浪地球3：人类命运的最后抉择',
    desc: '太阳急速老化膨胀，地球面临被吞噬的危机。人类启动"流浪地球计划"的终极阶段，在浩瀚宇宙中寻找新的家园。',
    tag: '科幻巨制',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20adventure%20scene%2C%20massive%20spaceship%20near%20Earth%2C%20dramatic%20cosmic%20lighting%20with%20orange%20and%20blue%2C%20cinematic%20wide%20shot%2C%20grand%20scale%2C%20stars%20and%20nebula&width=800&height=500&seq=card-wandering-97&orientation=landscape',
  },
  {
    title: '封神第二部：神话史诗再临',
    desc: '姜子牙率领众神迎战殷商大军，一场决定天下命运的旷世之战即将爆发。视觉特效全面升级，打造华语神话史诗新高度。',
    tag: '神话史诗',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20epic%20battle%2C%20warriors%20with%20spears%2C%20dramatic%20golden%20light%2C%20misty%20battlefield%2C%20cinematic%20composition%2C%20heroic%20scale%2C%20rich%20crimson%20and%20gold&width=800&height=500&seq=card-fengshen-97&orientation=landscape',
  },
  {
    title: '奥本海默：原子弹背后的天才与毁灭',
    desc: '诺兰最新力作，讲述"原子弹之父"罗伯特·奥本海默的传奇人生。从理论物理到毁灭性武器，一位天才内心的荣耀与挣扎。',
    tag: '传记剧情',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20historical%20period%20laboratory%20scene%2C%20intense%20scientist%20at%20work%2C%20high%20contrast%20lighting%2C%20vintage%201940s%20aesthetic%2C%20deep%20shadows%2C%20powerful%20moody%20atmosphere&width=800&height=500&seq=card-oppenheimer-97&orientation=landscape',
  },
  {
    title: '哪吒之魔童闹海：国漫巅峰续作',
    desc: '天劫之后哪吒与敖丙灵魂尚存，太乙真人用七色宝莲重塑肉身。更大的危机正在逼近，少年英雄命运将走向何方？',
    tag: '动画神作',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20style%2C%20young%20hero%20with%20fire%20powers%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20dynamic%20action%20pose%2C%20mythological%20Chinese%20aesthetic%2C%20cinematic%20lighting&width=800&height=500&seq=card-nezha-97&orientation=landscape',
  },
  {
    title: '沙丘2：沙漠星球史诗续章',
    desc: '保罗·厄崔迪与弗雷曼人并肩作战，踏上向摧毁他家庭的阴谋者复仇之路。史诗级科幻巨制，震撼视觉体验。',
    tag: '史诗科幻',
    img: 'https://readdy.ai/api/search-image?query=Sprawling%20desert%20planet%20landscape%2C%20epic%20sci-fi%20scene%20with%20sand%20dunes%2C%20dramatic%20golden%20hour%20lighting%2C%20grand%20scale%20cinematography%2C%20mysterious%20atmosphere%2C%20warm%20sand%20tones&width=800&height=500&seq=card-dune-97&orientation=landscape',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          推荐影片
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          编辑精选，本周最值得观看的五部电影
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {cards.map((card) => (
            <article key={card.title} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1">
              <div className="relative h-48 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-0.5 rounded-full bg-accent-500 text-black text-xs font-bold">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}